import React, { useEffect, useMemo, useState } from "react";
import { SlovHeader } from "./KCATSNIGHT_slovHeader";

const MAX_MESSAGES = 5;
const MAX_LENGTH = 400;

const countMessages = (messages, senderIndex) =>
    messages.filter((message) => Number(message?.[1]) === Number(senderIndex)).length;

export const KCatsTuringChatScreen = (props) => {
    const data = props.data || { round: 0, chatId: -1, selfIndex: 0, messages: [] };

    const [messages, setMessages] = useState(Array.isArray(data.messages) ? data.messages : []);
    const [counts, setCounts] = useState([0, 0]);
    const [text, setText] = useState("");

    useEffect(() => {
        props.CBcolor("#777777");
    }, []);

    useEffect(() => {
        const initialMessages = Array.isArray(data.messages) ? data.messages : [];
        setMessages(initialMessages);
        setCounts([
            countMessages(initialMessages, 0),
            countMessages(initialMessages, 1),
        ]);
        setText("");
    }, [data.round, data.chatId]);

    useEffect(() => {
        if (!props.update || Number(props.update.chatId) !== Number(data.chatId)) {
            return;
        }

        setMessages(Array.isArray(props.update.messages) ? props.update.messages : []);
        setCounts([
            Number(props.update.count0) || 0,
            Number(props.update.count1) || 0,
        ]);
    }, [props.update]);

    const selfIndex = Number(data.selfIndex) || 0;
    const myCount = counts[selfIndex] || 0;
    const limitReached = myCount >= MAX_MESSAGES;
    const trimmedText = text.trim();

    const rejectText = useMemo(() => {
        if (!props.reject || Number(props.reject.chatId) !== Number(data.chatId)) {
            return "";
        }

        if (props.reject.reason === "limit") {
            return "Вы уже отправили 5 сообщений в этом чате.";
        }

        return "Сообщение не было отправлено.";
    }, [props.reject, data.chatId]);

    const sendCurrentMessage = () => {
        if (limitReached || trimmedText.length === 0) {
            return;
        }

        props.sendMessage(
            `sendtoserver|slov\\addtext\\kcatsuring_chat\\${data.chatId}\\${encodeURIComponent(trimmedText)}`
        );
        setText("");
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            sendCurrentMessage();
        }
    };

    return (
        <div id="game">
            <SlovHeader />

            <div style={{ margin: "14px auto", width: "92%", maxWidth: "720px" }}>
                <div className="divtext_slov"><b>Тест Кикецюринга</b></div>
                <div style={{ marginTop: "6px", color: "#333" }}>Раунд {data.round}</div>
                <div style={{ marginTop: "8px", fontSize: "14px", color: "#666" }}>
                    Вы общаетесь с неизвестным игроком. Определите, KCats это или нет.
                </div>

                <div
                    style={{
                        marginTop: "16px",
                        border: "1px solid #cfcfcf",
                        borderRadius: "12px",
                        background: "#f7f7f7",
                        minHeight: "260px",
                        maxHeight: "52vh",
                        overflowY: "auto",
                        padding: "12px",
                    }}
                >
                    {messages.length === 0 ? (
                        <div style={{ color: "#888", textAlign: "center", paddingTop: "90px" }}>
                            Сообщений пока нет. Можете написать первым.
                        </div>
                    ) : (
                        messages.map((message, index) => {
                            const senderIndex = Number(message?.[1]);
                            const isMine = senderIndex === selfIndex;
                            return (
                                <div
                                    key={`${index}-${senderIndex}`}
                                    style={{
                                        display: "flex",
                                        justifyContent: isMine ? "flex-end" : "flex-start",
                                        marginBottom: "9px",
                                    }}
                                >
                                    <div
                                        style={{
                                            maxWidth: "82%",
                                            padding: "9px 12px",
                                            borderRadius: "12px",
                                            background: isMine ? "#dfeeff" : "#ffffff",
                                            border: "1px solid #d5d5d5",
                                            color: "#111",
                                            whiteSpace: "pre-wrap",
                                            overflowWrap: "anywhere",
                                            textAlign: "left",
                                        }}
                                    >
                                        <div style={{ fontSize: "11px", color: "#777", marginBottom: "3px" }}>
                                            {isMine ? "Вы" : "Собеседник"}
                                        </div>
                                        {String(message?.[0] ?? "")}
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>

                <div style={{ marginTop: "10px", fontSize: "14px", color: limitReached ? "#a00000" : "#444" }}>
                    Ваши сообщения: {myCount}/{MAX_MESSAGES}
                </div>

                {rejectText !== "" && (
                    <div style={{ marginTop: "8px", color: "#a00000", fontSize: "14px" }}>
                        {rejectText}
                    </div>
                )}

                <textarea
                    autoComplete="off"
                    className="FormInput"
                    style={{ width: "92%", minHeight: "72px", marginTop: "12px", resize: "vertical" }}
                    placeholder={limitReached ? "Лимит сообщений исчерпан" : "Напишите сообщение..."}
                    maxLength={MAX_LENGTH}
                    value={text}
                    disabled={limitReached}
                    onChange={(event) => setText(event.target.value)}
                    onKeyDown={handleKeyDown}
                />

                <div style={{ fontSize: "12px", color: "#777", marginTop: "3px" }}>
                    {text.length}/{MAX_LENGTH} символов · Enter — отправить, Shift+Enter — новая строка
                </div>

                <button
                    type="button"
                    disabled={limitReached || trimmedText.length === 0}
                    onClick={sendCurrentMessage}
                    style={{ marginTop: "10px" }}
                >
                    Отправить
                </button>
            </div>
        </div>
    );
};
